module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row mb10"
  }, [_c('div', {
    staticClass: "col-xs-12 clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/cgd/by/person/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" "), _c('span', [_vm._v("创建教学团队")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('NbFilter', {
    attrs: {
      "pager": _vm.pager,
      "callback": _vm.search
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.pager.persons), function(person) {
    return _c('div', {
      staticClass: "bg-white p10 mt10 border-radius-4"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12 cursor",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$router.push('/cgd/by/person/detail/' + person.id)
        }
      }
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [(person.image && person.image.url) ? _c('img', {
      staticClass: "img-rounded w120",
      attrs: {
        "src": person.image.url
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "pull-right action-buttons mt2"
    }, [_c('a', {
      attrs: {
        "title": "移到最前"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.top(person)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up text-primary f20"
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "title": "编辑"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$router.push('/cgd/by/person/edit/' + person.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil text-info f20"
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": "删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.confirmDel(person)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger f20"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('div', [_c('span', {
      staticClass: " f18 black"
    }, [_vm._v(_vm._s(person.name))])]), _vm._v(" "), (person.title) ? _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t头衔：" + _vm._s(person.title) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (person.phone) ? _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t电话：" + _vm._s(person.phone) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (person.office) ? _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t办公地点：" + _vm._s(person.office) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (person.email) ? _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t邮件：" + _vm._s(person.email) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "mr10"
    }, [_vm._v("#" + _vm._s(person.id))]), _vm._v(" "), _c('span', {
      staticClass: "mr10"
    }, [_vm._v("创建于:" + _vm._s(_vm._f("simpleDate")(person.createTime)))])])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt20"
  }, [_c('NbPager', {
    attrs: {
      "pager": _vm.pager,
      "callback": _vm.refresh
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left f24"
  }, [_c('i', {
    staticClass: "fa fa-fire text-success"
  }), _vm._v(" "), _c('span', [_vm._v("教学团队列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5995448e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/person/List.vue
// module id = 987
// module chunks = 1